import {
  put,
  all,
  takeLatest,
} from 'redux-saga/effects';
import * as types from './types';
import * as baseTypes from './base/types';
import * as historicalRangeTypes from './historicalRangeData/types';
import * as liveTypes from './liveData/types';

import { sagas as baseSagas } from './base';
import { sagas as historicalRangeSagas } from './historicalRangeData';
import { sagas as liveSagas } from './liveData';
import { sagas as savedDashboardSagas } from './dashboard';
import { sagas as tempDashboardSagas } from './tempDashboard';
import { sagas as sharingSagas } from './sharing';

function* init() {
  yield all([
    put({ type: baseTypes.INIT }),
    put({ type: historicalRangeTypes.INIT }),
    put({ type: liveTypes.INIT }),
  ]);
}

function* reset() {
  yield init();
}

function* watchReset() {
  yield takeLatest(types.RESET, reset);
}

export default [
  init,
  watchReset,
  ...baseSagas,
  ...historicalRangeSagas,
  ...liveSagas,
  ...savedDashboardSagas,
  ...tempDashboardSagas,
  ...sharingSagas,
];
